import React from 'react';
import ReportingFinancesW9TrackingPage from '../components/ReportingFinancesW9TrackingPage';

const ReportingFinancesW9TrackingApp = (props) => (
  <ReportingFinancesW9TrackingPage {...props} />
);

export default ReportingFinancesW9TrackingApp;
